import { MIME_MICROSOFT, MIME_PREFIX_RAW } from '../constants/mimes';

export const isMicrosoftDocument = (mimeType) => MIME_MICROSOFT.some((i) => i === mimeType);

export const isRawPrefix = (prefix) => {
    let isRaw = false;

    MIME_PREFIX_RAW.forEach((mimePrefix) => {
        if (isRaw) return;

        if (prefix.startsWith(mimePrefix)) {
            isRaw = true;
        }
    });

    return isRaw;
};
